import { DateTime } from 'luxon'

// Restituisce lunedi' e venerdi' della settimana lavorativa precedente rispetto alla data fornita.
export const getPreviousWorkWeek = (today: Date): [Date, Date] => {
  const day = today.getDay()
  const diffToMonday = day === 0 ? -6 : 1 - day
  const currentMonday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + diffToMonday, 0, 0, 0)
  const previousMonday = new Date(
    currentMonday.getFullYear(),
    currentMonday.getMonth(),
    currentMonday.getDate() - 7,
    0,
    0,
    0,
  )
  const previousFriday = new Date(
    previousMonday.getFullYear(),
    previousMonday.getMonth(),
    previousMonday.getDate() + 4,
    0,
    0,
    0,
  )
  return [previousMonday, previousFriday]
}

// Giorno locale in formato yyyy-MM-dd, come atteso dai parametri from/to delle API delle anomalie.
export const toApiDate = (date: Date): string => DateTime.fromJSDate(date).toISODate() ?? ''

// Estremi inclusi del mese solare precedente.
export const getPreviousMonth = (): [Date, Date] => {
  const now = new Date()
  return [
    new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0),
    new Date(now.getFullYear(), now.getMonth(), 0, 0, 0, 0),
  ]
}
